export default __webpack_public_path__ + "static/media/bike.a6b978db.gif";